import {AfterViewInit, Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {MenuItems} from '../menu/menu-items/menu-items';
import {Router, RouterModule} from '@angular/router';
import {ChkService} from '../../shared/services/chk.service';
import {DataService} from '../../shared/services/data.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FooterLogoListComponent } from '../../widgets/footerLogoList/footerLogoList.component';
import * as $ from 'jquery';

@Component({
  selector: '[angly-footer2]',
  templateUrl: './footer2.component.html',
  styleUrls: ['./footer2.component.scss'],
  standalone: true,
  imports: [ CommonModule, RouterModule, FooterLogoListComponent ]
})
export class Footer2Component implements OnInit, AfterViewInit {

  footerData = DataService.FOOTER_DATA;

  constructor(public menuItems: MenuItems, private service: ChkService, public router: Router, @Inject(PLATFORM_ID) private platformId: object) {
  }

  /* Variables */
  footer2Menu: any;
  footerLogo: any;

  subscribeFormClasses: any = {rowClass: 'row', fieldClass: 'col-sm-12 col-md-6'};

  ngOnInit() {

    this.footer2Menu = this.menuItems.getFooter2();

    this.service.getFooterLogoList().subscribe(response => {
        this.footerLogo = response;
      },
      err => console.log(err),
      () => this.footerLogo
    );
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#back-top').hide();
      window.addEventListener('scroll', this.scroll.bind(this), true);
    }
  }
  

  scroll() {
    if (document.body.scrollTop > 300) {
      $('#back-top').fadeIn(0);
    } else {
      $('#back-top').fadeOut(0);
    }
  }


  topScroll(e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  }

}
